/*
 * FICHIER: MainBackgroundWrapper.js
 * BUT: Wrapper d'arrière-plan principal pour l'application
 * 
 * Ce composant fournit un wrapper de base pour l'arrière-plan principal :
 * - Couleur de fond cohérente pour toute l'application
 * - Hauteur minimale plein écran garantie
 * - Base pour le layout général
 * 
 * UTILISATION :
 * Wrapper de très haut niveau pour encapsuler le contenu principal
 * et s'assurer que l'arrière-plan couvre toujours tout l'écran.
 * 
 * PATTERN :
 * - Styled component simple pour layout de base
 * - Utilisation de variables CSS pour cohérence
 * - Composant minimal et focalisé
 */

import styled from 'styled-components';    // CSS-in-JS pour styles

/**
 * WRAPPER PRINCIPAL: Container d'arrière-plan de l'application
 * 
 * Assure un arrière-plan cohérent et une hauteur minimale
 * plein écran pour tous les contenus de l'application.
 */
const MainBackgroundWrapper = styled.div`
  background-color: var(--body-bg);    // Couleur d'arrière-plan définie dans les variables CSS
  min-height: 100vh;                   // Hauteur minimale = 100% du viewport (plein écran)
`;

export default MainBackgroundWrapper; 